import { type FC } from "react"
import { useSearchParams } from "react-router-dom"
import { useModal } from "@/modals"
import { Modal } from "@/ui/Modal"
import styles from "./PlayWithFriendModal.module.scss"
import { CreatorView } from "./ui/CreatorView"
import { JoinerView } from "./ui/JoinerView"

const modalType = "playWithFriend"

export const PlayWithFriendModal: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const { modal } = useModal(modalType)

  const friendInviteCodeTg =
    window.location.search.split("friendInviteCode_")[1]
  const friendInviteCodeParam = searchParams.get("friendInviteCode")

  const joinToken = friendInviteCodeTg || friendInviteCodeParam
  const isJoinerMode = !!joinToken

  const handleClose = () => {
    modal.close()
    setSearchParams(undefined)
  }

  return (
    <Modal.Center
      type={modalType}
      className={styles.PlayWithFriendModal}
      body={{ className: styles.PlayWithFriendModal_body }}
      isCanClose={false}
    >
      {isJoinerMode ? (
        <JoinerView token={joinToken} onClose={handleClose} />
      ) : (
        <CreatorView onClose={handleClose} />
      )}
    </Modal.Center>
  )
}
